<div class="container-fluid">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-6">
          <table>
            <td style="vertical-align: middle;"><img src="assets/img/global/folha.png" alt="" title="" width="42" height="42">
            </td>
            <td>
              <p
                [ngClass]="this.login.contraste ? 'titulo-txt-contraste fonte-acessibilidade m-0' : 'titulo-txt-normal fonte-acessibilidade m-0'">
                REMUNERAÇÃO DO SERVIDOR</p>
              <p
                [ngClass]="this.login.contraste ? 'subtitulo-txt-contraste fonte-acessibilidade m-0' : 'subtitulo-txt-normal fonte-acessibilidade m-0'">
                EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}</p>
            </td>
          </table>
        </div>
        <div class="col-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
          </button>
          <button (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Voltar a pesquisar" height="22"
              width="22">
            Voltar
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label
            [ngClass]="this.login.contraste ? 'text-white font-weight-bold fonte-acessibilidade' : 'text-black-50 font-weight-bold fonte-acessibilidade'">
            {{login.orgao.codigo}} {{login.orgao.nome}}
          </label>
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-4'" />
      <div class="form-row">
        <label for="referencia" class="col-sm-2 col-form-label">Mês/Ano:</label>
        <div class="form-group col-10 mb-0">
          <input readonly disabled value="{{entidade.referencia}}" type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
            id="referencia">
        </div>
      </div>
      <div class="form-row" *ngIf="entidade.funcionario">
        <label for="chapa" class="col-sm-2 col-form-label">Chapa Nº:</label>
        <div class="form-group col-10 mb-0">
          <input readonly disabled value="{{entidade.funcionario.codigo}}" type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
            id="chapa">
        </div>
      </div>

      <div class="form-row" *ngIf="entidade.funcionario">
        <label for="nome" class="col-sm-2 col-form-label">Nome:</label>
        <div class="form-group col-10 mb-0">
          <input readonly disabled value="{{entidade.funcionario.pessoa.nome}}" readonly type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
            id="nome">
        </div>
      </div>
      <div class="form-row" *ngIf="entidade.funcionario">
        <label for="cargo" class="col-sm-2 col-form-label">Cargo:</label>
        <div class="form-group col-10 mb-0">
          <input readonly disabled value="{{entidade.funcionario.cargo.nome}}" type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext font-weight-bold text-white' : 'form-control-plaintext font-weight-bold'"
            id="cargo">
        </div>
      </div>
      <div class="row" *ngIf="entidade.funcionario">
        <label for="data_admissao" class="col-sm-2 col-form-label">Data Admissão:</label>
        <div class="form-group col-md-10 mb-0">
          <input readonly disabled value="{{entidade.funcionario.data_admissao | date:'dd/MM/yyyy':'GMT'}}" type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="data_admissao">
        </div>
      </div>
      <div class="row" *ngIf="entidade.funcionario">
        <label for="tipo" class="col-sm-2 col-form-label">Tipo de Admissão:</label>
        <div class="form-group col-md-10 mb-0">
          <input readonly disabled value="{{entidade.funcionario.forma_admissao}}" type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'" id="tipo">
        </div>
      </div>
      <div class="row" *ngIf="entidade.funcionario">
        <label for="regime" class="col-sm-2 col-form-label">Regime:</label>
        <div class="form-group col-md-10 mb-0">
          <input readonly disabled value="{{entidade.funcionario.regime}}" type="text"
            [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
            id="regime">
        </div>
      </div>
      <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-4'" />
      <div class="row">
        <div class="col-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Salário Base:</label>
            <div class="form-group col-md-8 mb-0">
              <input type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                readonly value="{{entidade.salario_base | number:'1.2-2'}}">
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">Valor Bruto:</label>
            <div class="form-group col-md-8 mb-0">
              <input type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                readonly value="{{entidade.valor_bruto | number:'1.2-2'}}">
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">Total Desconto:</label>
            <div class="form-group col-md-8 mb-0">
              <input type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                readonly value="{{entidade.valor_desconto | number:'1.2-2'}}">
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">Valor Líquido:</label>
            <div class="form-group col-md-8 mb-0">
              <input type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                readonly value="{{entidade.valor_liquido | number:'1.2-2'}}">
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">FGTS Mês:</label>
            <div class="form-group col-md-8 mb-0">
              <input type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                readonly value="{{entidade.valor_fgts | number:'1.2-2'}}">
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">Base INSS:</label>
            <div class="form-group col-md-8 mb-0">
              <input type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                readonly value="{{entidade.base_inss | number:'1.2-2'}}">
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">Base IRRF:</label>
            <div class="form-group col-md-8 mb-0">
              <input type="text"
                [ngClass]="this.login.contraste ? 'form-control-plaintext text-white' : 'form-control-plaintext'"
                readonly value="{{entidade.base_irrf | number:'1.2-2'}}">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table
            [ngClass]="login.contraste ? 'table table-dark fonte-acessibilidade' : 'table table-eddy fonte-acessibilidade'">
            <thead>
              <tr style="height: 42px;">
                <th scope="col" class="text-left">Evento</th>
                <th scope="col" class="text-right">Referência</th>
                <th scope="col" class="text-right">Proventos</th>
                <th scope="col" class="text-right">Descontos</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listaEventos">
                <td style="width: 40%;" class="text-left">{{item.evento.nome}}</td>
                <td style="width: 20%;" class="text-right">{{item.quantidade}}</td>
                <td style="width: 20%;" class="text-right" *ngIf="item.evento.tipo === 'P'">
                  {{item.valor | number:'1.2-2'}}</td>
                <td style="width: 20%;" class="text-right" *ngIf="item.evento.tipo !== 'P'">-</td>
                <td style="width: 20%;" class="text-right" *ngIf="item.evento.tipo === 'D'">
                  {{item.valor | number:'1.2-2'}}</td>
                <td style="width: 20%;" class="text-right" *ngIf="item.evento.tipo !== 'D'">-</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>
